import React, {useState} from "react"
import {Formik, Field, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import ReCAPTCHA from "react-google-recaptcha";
import Collapse from "react-bootstrap/Collapse";
import Alert from "react-bootstrap/Alert";
const qs = require('query-string');

class Report extends React.Component {
    constructor(props) {
        super(props);

        const parsed = qs.parse(window.location.search.substring(1));

        this.state = {
            actionSuccessful: null,
            sendEnabled: false,
            entity: parsed["name"],
        }
    }

    enableSend = () => {
        this.setState({sendEnabled: true})
    }

    disableSend = () => {
        this.setState({sendEnabled: true})
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="block-heading-two">
                            <h3><span><i className="fas fa-siren"></i> Reportar</span></h3>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="block-heading-two">
                            <span>Es muy importante para nosotros brindar un servicio de calidad y excelencia.
                                Por ese motivo creamos este espacio para denunciar el uso inadecuado que le pueda estar
                                dando un Proveedor o Usuario a la plataforma.
                            </span>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <Collapse in={this.state.actionSuccessful!=null}>
                            <div>
                                <Alert
                                    variant={this.state.actionSuccessful == true ? 'success' : this.state.actionSuccessful == false ? 'danger' : ''}>
                                    <Alert.Heading>{this.state.successTitle}</Alert.Heading>
                                    <p>
                                        {this.state.actionResult}
                                    </p>
                                </Alert>
                            </div>
                        </Collapse>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <Formik
                            initialValues={{
                                email: '',
                                message: '',
                                entity: this.state.entity,
                            }}
                            validationSchema={Yup.object().shape({
                                email: Yup.string()
                                    .email('Email es inválido')
                                    .required('E-mail es requerido'),
                                message: Yup.string()
                                    .required('Es texto del mensaje es requerido'),
                                entity: Yup.string()
                                    .required('Es necesario especificar una Empresa o Usuario'),
                            })}
                            onSubmit={fields => {
                                this.setState({sendEnabled: false})
                                fetch(process.env.PUBLIC_URL + '/v1/services/report', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    },
                                    body: JSON.stringify(fields, null, 4),
                                })
                                    .then((response) => {
                                            if (response.status < 300) {
                                                this.setState({
                                                    sendEnabled: true,
                                                    actionSuccessful: true,
                                                    actionResult: "Denuncia enviada, agradecemos su interes en la mejora del servicio."
                                                })
                                            } else {
                                                this.setState({
                                                    sendEnabled: true,
                                                    actionSuccessful: false,
                                                    actionResult: "Se produjo un error al intentar enviar los datos. Por favor intente más tarde."
                                                })
                                            }
                                            response.json()

                                        },

                                        (error) => {
                                            this.setState({
                                                sendEnabled: true,
                                                actionSuccessful: false,
                                                actionResult: "Se produjo un error al intentar enviar los datos. Por favor intente más tarde."
                                            })
                                        }

                                    );

                            }}
                            render={({errors, status, touched, setFieldValue}) => (
                                <Form encType="multipart/form-data">
                                    <div className="form-group">
                                        <label htmlFor="entity">Empresa / Usuario</label>
                                        <Field name="entity" type="text"
                                               className={'form-control' + (errors.entity && touched.entity ? ' is-invalid' : '')}/>
                                        <ErrorMessage name="entity" component="div" className="invalid-feedback"/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="email">Su e-mail</label>
                                        <Field name="email" type="text"
                                               className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')}/>
                                        <ErrorMessage name="email" component="div" className="invalid-feedback"/>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="message">Su observación</label>
                                        <Field component="textarea" id="message" name="message" rows="4" cols="50"
                                               className={'form-control' + (errors.message && touched.message ? ' is-invalid' : '')}/>
                                        <ErrorMessage name="message" component="div" className="invalid-feedback"/>
                                    </div>
                                    <div className="form-group">
                                        <ReCAPTCHA
                                            sitekey={process.env.REACT_APP_RE_CAPTCHA_KEY}
                                            onChange={this.enableSend}/>
                                    </div>
                                    <div className="form-group">
                                        <div id="resultMessage"></div>
                                    </div>
                                    <div className="form-group">
                                        <button id="actionSend" disabled={!this.state.sendEnabled} type="submit"
                                                className="btn btn-primary mr-2">Reportar
                                        </button>
                                    </div>
                                    <ErrorMessage name="custom" render={msg => <div>{msg}</div>}/>
                                </Form>
                            )}
                        />
                    </div>
                </div>
            </div>)
    }
};

export default Report